import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const Navbar = ({ onNotifyClick }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleAnchor = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FDFBF7]/90 backdrop-blur-md border-b border-[#E5E8E3]"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-brand"
          className="font-serif-display text-2xl md:text-[26px] text-[#1A362D] tracking-tight"
        >
          activehuman
          <span className="text-[#C29B62]">.</span>
        </Link>

        <div className="hidden md:flex items-center gap-10 text-sm tracking-wide text-[#1A362D]/80">
          <a href="#product" onClick={handleAnchor("product")} className="activehuman-link-underline" data-testid="nav-product">
            Product
          </a>
          <a href="#benefits" onClick={handleAnchor("benefits")} className="activehuman-link-underline" data-testid="nav-benefits">
            Why D3
          </a>
          <a href="#story" onClick={handleAnchor("story")} className="activehuman-link-underline" data-testid="nav-story">
            Our Story
          </a>
        </div>

        <button
          onClick={onNotifyClick}
          data-testid="nav-notify-btn"
          className="group inline-flex items-center gap-2 px-5 md:px-6 py-2.5 bg-[#1A362D] text-[#FDFBF7] text-xs md:text-sm tracking-[0.18em] uppercase hover:bg-[#132720] transition-colors duration-300"
        >
          Notify Me
          <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">→</span>
        </button>
      </nav>
    </header>
  );
};
